import * as React from "react"

import { cn } from "@/frontend/lib/utils"
import { inputStyles } from "@/frontend/components/ui/input"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        inputStyles,
        "flex field-sizing-content min-h-16 w-full px-2.5 py-2",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
